import { all } from 'redux-saga/effects'
import { dashboardFlow } from './dashboard/DashboardReducer'
import { loginPageFlow } from './login'
import { mixedHealthServersSaga } from './dashboard/mixedHealthServers/MixedHealthServersReducer'
import { problematicServicesSaga } from './dashboard/problematicServices/ProblematicServicesReducer'
import { containersProblematicServicesSaga } from './dashboard/containersProblematicServices/ContainersProblematicServicesReducer'
import { searchServicesSaga } from './dashboard/searchServices/SearchServicesTableReducer'
import { fetcher as searchByLogIDSaga } from './dashboard/searchByLogId/SearchServiceIdReducer'
import { serverTreeSaga } from './dashboard/serverTree/ServerTreeReducer'
import { serviceStatusSaga } from './dashboard/ServiceStatusTableReducer'
import { settingsFlow } from './settings'
import { signupFlow } from './signup/signup'
import { statsSaga } from './dashboard/stats/StatsReducer'
import { wrapperPageFlow } from './wrapper'
import { regionsSaga } from './dashboard/regions/RegionsReducer'
import { clustersSaga } from './dashboard/clusters/ClustersReducer'
import { licensesSaga } from './dashboard/Licenses/LicensesReducer'
import { saga as expiredApps} from './dashboard/expiredApps/ExpiredAppsReducer'

export default function* rootSaga() {
    yield all([
        wrapperPageFlow(),
        settingsFlow(),
        mixedHealthServersSaga(),
        loginPageFlow(),
        signupFlow(),
        problematicServicesSaga(),
        containersProblematicServicesSaga(),
        dashboardFlow(),
        serviceStatusSaga(),
        searchServicesSaga(),
        searchByLogIDSaga.saga(),
        serverTreeSaga(),
        regionsSaga(),
        clustersSaga(),
        licensesSaga(),
        statsSaga(),
        expiredApps(),
    ])
}
